export enum MonitoringQuickFilter {
  State = 'State'
}
